import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {
    GenericCameraSettings,
    GenericCameraSettingsChild,
    InputType,
    CameraSettingsErrorStateMatcher,
    RenderType
} from '@pages/camera-settings/models';

@Component({
    selector: 'mat-generic-form-field-disabled',
    templateUrl: './mat-generic-form-field-disabled.component.html',
    styleUrls: ['./mat-generic-form-field-disabled.component.scss']
})
export class MatGenericFormFieldDisabledComponent implements OnInit {
    @Input() property: GenericCameraSettings;
    @Input() disabled: boolean = false;
    @Input() manualRefresh: EventEmitter<void> = new EventEmitter<void>();
    @Input() form!: FormGroup;

    @Output() onChange = new EventEmitter<any>();

    options: any;
    childProperties: GenericCameraSettingsChild[] = [];
    matcher = new CameraSettingsErrorStateMatcher();

    constructor() {}

    get isValid() {
        if (this.form) {
            return this.form.controls[this.property.propertyName].valid;
        } else {
            return false;
        }
    }

    public get RenderType(): typeof RenderType {
        return RenderType;
    }

    public get InputType(): typeof InputType {
        return InputType;
    }

    ngOnInit(): void {
        if (this.property.renderType === RenderType.Slider) {
            if (
                this.property.stepsArray &&
                this.property.stepsArray.length > 0
            ) {
                this.options = {
                    showTicks: true,
                    disabled: true,
                    stepsArray: this.property.stepsArray
                };
            } else {
                this.options = {
                    floor: this.property.min,
                    ceil: this.property.max,
                    step: 1,
                    showTicks: true,
                    disabled: true
                };
            }
        }

        if (this.property.renderType === RenderType.CustomSlider) {
            this.options = {
                showTicks: true,
                disabled: true,
                stepsArray: this.property.customSteps
            };
        }
    }
}
